import { ApiService } from '@/services/api.service';
import S3Api from '@/services/S3Api';

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    submitFormConfig: (store, params) =>
      new Promise((resolve, reject) => {
        ApiService.post('/forms/config', params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      }),
    deleteFormConfig: (store, id) =>
      new Promise((resolve, reject) => {
        ApiService.delete(`/forms/config/${id}`)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      }),
    getFormConfigs: (store, { domain }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/forms/${domain}/config`, {})
          .then(({ data }) => {
            resolve(data.configs);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getCCFormTypes: (store, { domain, layout }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/forms/${domain}/ccFormTypes/?layout=${layout}`, {})
          .then(({ data }) => {
            resolve(data.formTypes);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getAssets: (store, { domain }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/assets/${domain}`, {})
          .then(({ data }) => {
            resolve(data.assetsData);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    uploadAsset: ({ dispatch }, { params, file }) =>
      new Promise((resolve, reject) => {
        ApiService.post('/domains/presign', params)
          .then((data) => {
            const url = data.data.presignedUrl;
            dispatch('uploadFile', { url, file }).then(() => {
              resolve(data);
            });
          })
          .catch((error) => {
            reject(error);
          });
      }),
    uploadFile: ({ commit }, { url, file }) =>
      new Promise((resolve, reject) => {
        S3Api(url, file)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            if (err && err.response && err.response.status === 403) {
              commit('');
            }
            reject(err);
          });
      }),
    getMessageConfigs: (store, { domain, page, statusFilter, priorityFilter, typeFilter }) =>
      new Promise((resolve, reject) => {
        ApiService.get(
          `/messages/${domain}?statusFilter=${statusFilter}&priorityFilter=${priorityFilter}&typeFilter=${typeFilter}&pageNumber=${page}`,
          {},
        )
          .then(({ data }) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    getSingleMessageConfig: (store, { domain, id }) =>
      new Promise((resolve, reject) => {
        ApiService.get(`/messages/single/${domain}/${id}`, {})
          .then(({ data }) => {
            resolve(data.singleMessage[0]);
          })
          .catch((error) => {
            reject(error.response);
          });
      }),
    deleteMessage: (store, { domain, id }) =>
      new Promise((resolve, reject) => {
        ApiService.delete(`/messages/${domain}/${id}`)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      }),
    submitMessageConfig: (store, params) =>
      new Promise((resolve, reject) => {
        ApiService.post('/messages/save', params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      }),
    editMessageConfig: (store, { id, params }) =>
      new Promise((resolve, reject) => {
        ApiService.post(`/messages/${id}`, params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      }),
  },
};
